import { GroupReferenceKey } from './CartSlice';
import '_design/sass/cart.scss';
import FetchStatus from '../../common/types/FetchStatus';
import { useState } from 'react';
import { GroupKeyLink } from 'domain/components/application/GroupKeyLink';

interface CartItem {
  groupRefKey: string;
  referenceNum: string;
  address: string;
  price: string;
  renewal: boolean;
}

interface ICartPresenter {
  cartItems: CartItem[];
  orderSubtotal: string;
  removeFromCart: (id: GroupReferenceKey) => void;
  checkout: () => void;
  checkoutLoading: FetchStatus;
}

function CartPresenter(props: ICartPresenter) {
  const [checkoutBtnClicked, setCheckoutBtnClicked] = useState(false);

  let appTable;
  if (props.cartItems.length == 0) {
    appTable = <h4>No items in your cart</h4>;
  } else {
    appTable = (
      <>
        <table id='cart-grid'>
          <thead>
            <tr>
              <th id='cart-grid-item-title'>Item</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            {props.cartItems.map((cartItem) => (
              <>
                <tr key={Math.random()}>
                  <td>
                    <div className='cart-grid-item'>
                      <h5 style={{ marginBottom: '10px' }}>
                        Payment for House Share Registration{' '}
                        {cartItem.renewal ? 'Renewal' : ''}
                      </h5>
                      <div style={{ display: 'flex' }}>
                        <span>For Ref&nbsp;</span>
                        <span style={{ textDecoration: 'underline' }}>
                          <GroupKeyLink groupKey={cartItem.groupRefKey} />
                        </span>
                      </div>
                      <p>{cartItem.address}</p>
                    </div>
                  </td>
                  <td>${cartItem.price}</td>
                  <td>
                    <a
                      className='btn btn-primary'
                      onClick={() => props.removeFromCart(cartItem.groupRefKey)}
                    >
                      Remove
                    </a>
                  </td>
                </tr>
                <tr key={Math.random()} style={{ height: '10px' }}></tr>
              </>
            ))}
          </tbody>
        </table>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '10px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              minWidth: '150px',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <p>
                <b>Subtotal:</b>
              </p>
              <p>${props.orderSubtotal}</p>
            </div>
            <button
              className='btn btn-primary'
              disabled={
                props.checkoutLoading === FetchStatus.loading ||
                checkoutBtnClicked
              }
              onClick={() => {
                setCheckoutBtnClicked(true);
                props.checkout();
              }}
            >
              Checkout with eCheckout
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <div>
      <h1 className='cds-hero-heading'>Cart</h1>
      {appTable}
    </div>
  );
}

export default CartPresenter;
